// extracted by mini-css-extract-plugin
var _1 = "IdtnHxztrEh5FgyfXgOk";
export { _1 as "flexRow" }
